<ng-container *ngIf="componentConfig$ | async as config">
    <div [ngSwitch]="formStep" class="club-modal">
        <ng-container *ngSwitchCase="1">
            <div class="club-modal-body">
                <h3 [innerHtml]="config.select_reason.title"></h3>
                
                <ng-container
                *ngIf="(benefitsConfig$ | async) as benefitsConfig">
                    <p
                        *ngIf="benefitsConfig.benefits && benefitsConfig.benefits.length"
                        class="sub-title"
                        [innerHtml]="config.select_reason.benefits_title"
                    ></p>
                    <serviceos-web-benefits-list
                    [benefits]="benefitsConfig.benefits"
                    [texts]="config.select_reason.benefits_list"
                    ></serviceos-web-benefits-list>
                </ng-container>

                <div>
                    <p
                        class="sub-title"
                        [innerHtml]="config.select_reason.cancel_reasons_title"
                    ></p>
                    <form
                        [formGroup]="cancelReasonForm"
                        (ngSubmit)="submitSelectReasonStep()"
                        class="cancel-club-form"
                    >
                        <serviceos-ng-radio-group
                            formControlName="reason"
                            *ngIf="cancelReasons$ | async as cancelReasons"
                        >
                            <serviceos-ng-radio
                                [value]="reason"
                                *ngFor="let reason of cancelReasons"
                                >{{ reason.name }}</serviceos-ng-radio
                            >
                        </serviceos-ng-radio-group>
                        <serviceos-ng-form-field>
                            <textarea
                                formControlName="comment"
                                serviceosNgInput
                            ></textarea>
                        </serviceos-ng-form-field>
                    </form>
                </div>
            </div>
            <div class="club-modal-nav">
                <serviceos-ng-button
                    [isFullWidth]="true"
                    (click)="submitSelectReasonStep()"
                    [disable]="cancelReasonForm.errors?.formError"
                >
                    {{ config.select_reason.confirm_button_title }}
                </serviceos-ng-button>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="2">
            <div class="club-modal-body">
                <h3 [innerHtml]="config.thank_you.title"></h3>

                <div [innerHtml]="config.thank_you.content"></div>
            </div>

            <div class="club-modal-nav">
                <serviceos-ng-button [isFullWidth]="true" (click)="close()">
                    {{ config.thank_you.confirm_button_title }}
                </serviceos-ng-button>
            </div>
        </ng-container>
    </div>
</ng-container>
